import { Component } from '@angular/core';
import {BreadcrumbHeaderComponent} from '../../LandingPage/NavigationMenu/page-headline/page-headline.component';

@Component({
  selector: 'app-datenschutzerklaerung',
  standalone: true,
  imports: [
    BreadcrumbHeaderComponent
  ],
  templateUrl: './datenschutzerklaerung.component.html',
  styleUrl: './datenschutzerklaerung.component.scss'
})
export class DatenschutzerklaerungComponent {

}
